// extracted by mini-css-extract-plugin
export default {"page_container":"styles_page_container__1jArI"};